import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06aae866"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "release-announcement-modal__text mb-3" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "release-announcement-modal__text mb-3" }, " После — можно подключить только нужные вам функции. Узнайте подробнее и выберите подходящий вариант. ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "release-announcement-modal__text mb-3" }, " Бесплатный период завершён. Теперь вы можете подключить только нужные вам функции. ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "release-announcement-modal__text mb-3" }, " Узнайте подробнее и выберите подходящий вариант. ", -1))

import { ref, computed } from 'vue';
import TariffNotificationModal from '../../TariffNotificationModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReleaseAnnouncementModal',
  props: {
    freeAccessUntil: {},
    isTrialExpired: { type: Boolean }
  },
  emits: ["hidden", "confirm"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const formattedDate = computed(() => {
    const date = new Date(props.freeAccessUntil);
    return date.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' });
});

const modalRef = ref<InstanceType<typeof TariffNotificationModal>>();
function onConfirm() {
    emit('confirm');
    window.location.href = '/PaidFeatures';
}
function showModal() {
    modalRef.value?.show();
}

function hideModal() {
    modalRef.value?.hide();
}

__expose({
    show: showModal,
    hide: hideModal,
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TariffNotificationModal, {
    ref_key: "modalRef",
    ref: modalRef,
    title: "Мы запустили новую систему тарифов — теперь вы сами выбираете нужные функции",
    "image-url": "/assets/images/tariff/picture-new-tariff.png",
    onButtonClick: onConfirm,
    onHidden: _cache[0] || (_cache[0] = ($event: any) => (emit('hidden')))
  }, {
    default: _withCtx(() => [
      (!_ctx.isTrialExpired)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("p", _hoisted_1, " Все возможности платформы доступны бесплатно до " + _toDisplayString(formattedDate.value), 1),
            _hoisted_2
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_3,
            _hoisted_4
          ], 64))
    ]),
    _: 1
  }, 512))
}
}

})